import { RouteConfig } from 'vue-router';
const EliotPanel = () =>
    import(/* webpackChunkName: "eliot-panel" */ '~/views/EliotPanel.vue');

export function createEliotPanelRoutes(): RouteConfig[] {
    const ELIOTUSER = 0;
    const ELIOTGATEWAY = 1;
    const PLANT = 2;

    const routeElements = [
        {
            pathParticle: 'eliotuser',
            routeNameParticle: 'eliotuser',
            parameter: 'userIdentifier',
        },
        {
            pathParticle: 'eliotgateway',
            routeNameParticle: 'eliotgateway',
            parameter: 'eliotGatewayId',
        },
        {
            pathParticle: 'plant',
            routeNameParticle: 'plant',
            parameter: 'plantId',
        },
    ];

    // creates a routes array with the array from params for example
    // [
    //     [ELIOTUSER, PLANT],
    //     [ELIOTUSER, ELIOTGATEWAY],
    // ]
    // to create routes for
    // /eliotuser/:userIdentifier/plant/:plantId
    // /eliotuser/:userIdentifier/eliotgateway/:deviceliotid
    function createRoutes(arrayOfElementsArray: number[][]) {

        // creates a route by iterating through the elements array
        function createRoute(elementsArray: number[]) {
            let path = '';
            let name = '';
            const nameSeparator = '-';
            elementsArray.forEach((element, index) => {
                const { pathParticle, routeNameParticle, parameter } = routeElements[element];
                path = `${path}/${pathParticle}/:${parameter}`;
                name = `${name}${index > 0 ? nameSeparator : ''}${routeNameParticle}`;
            });
            return {
                path: `/support${path}`,
                name,
                component: EliotPanel,
                props: true,
            };
        }
        return arrayOfElementsArray.map((elementsArray) => createRoute(elementsArray));
    }

    const routes = createRoutes([
        [ELIOTUSER, ELIOTGATEWAY],
        [ELIOTUSER, PLANT],
        [PLANT],
        [ELIOTGATEWAY],
    ]);
    return routes;
}

export const eliotPanelRoutes = createEliotPanelRoutes();
